export default __webpack_public_path__ + "static/media/gymbooking.67c43fe9.svg";